const getTabsMeta = (tabs) => {
  const { scrollLeft } = tabs;
  const { left, right } = tabs.getBoundingClientRect();
  const tabsMeta = {
    scrollLeft,
    left,
    right,
  };
  return tabsMeta;
};

export default getTabsMeta;
